<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/customer-receipt/table">客户开票信息列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="公司名称"
                          prop="company_name">
              <el-input v-model="form.company_name" placeholder="请输入公司名称" :disabled="id > 0"></el-input>
            </el-form-item>
            <el-form-item label="开户行及账户"
                          prop="bank_info">
              <el-input v-model="form.bank_info" placeholder="请输入开户行及账户"></el-input>
            </el-form-item>
            <el-form-item label="地址及电话"
                          prop="address_phone">
              <el-input v-model="form.address_phone" placeholder="请输入地址及电话"></el-input>
            </el-form-item>
            <el-form-item label="税号"
                          prop="tax_number">
              <el-input v-model="form.tax_number" placeholder="请输入税号" :disabled="id > 0"></el-input>
            </el-form-item>
            <el-form-item v-if="id > 0" label="附件" prop="attached_file">
              <div class="view-navbar">
                <ul class="clear-both">
                  <li v-for="(item, index) in form.attached_file" :key="index">
                    <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                      <img v-if="item.type === 'pic'" style="width: 100px; height: 100px" :src="item.tmp_url" @click="onViewImage">
                      <i v-if="item.type === 'pdf' || item.type === 'eml'"
                          class="sj-icon-pdf"
                          style=" font-size:100px; margin-top: 50px"
                          @click="onGetPdfFile(item, index)"></i>
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </el-form-item>
            <el-form-item v-else label="添加附件" prop="attached_file">
              <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-change="onChangeFile"
                :before-remove="beforeRemove"
                multiple
                :limit="5"
                :on-exceed="handleExceed"
                :file-list="fileList"
                accept=".jpg, .jpeg, .png, .pdf, .eml"
                ref="upload" >
                <el-button size="small"
                           :loading="fileUploading"
                           type="primary">点击上传
                </el-button>
                <div slot="tip"
                      class="el-upload__tip">只能上传PNG/JPG/PDF/EML文件，允许上传多张
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="使用客户" prop="customer_ids">
            <div class="market" v-for="(item, index) in form.customer_ids" :key="index">
              <div style="display:flex; flex-direction: row; margin-top: 4px">
                <remote-select v-model="item.id"
                    placeholder="请输入关键词"
                    :queryRequest="customerRemoteMethod"
                    :findRequest="getCustomerInfoRemote"
                    clearable
                    valueKey="id"
                    labelKey="name"
                    idKey="id">
                </remote-select>
                <div style="display:flex; flex-direction: row; margin-left: 4px">
                  <el-button v-if="index === 0" size="mini" @click="addCustomer">添加</el-button>
                  <el-button v-if="index > 0" @click="deleteItemAt(index)" size="mini" type="danger">删除</el-button>
                </div>
              </div>
            </div>
            </el-form-item>
            <el-form-item label="账期"
                          prop="pay_condition_ids">
              <div class="market"
                   v-for="(item, index) in form.pay_condition_ids"
                   :key="index">
                <div style="display:flex; flex-direction: row; margin-top: 4px">
                  <remote-select v-model="item.id"
                                 placeholder="请输入账期名称"
                                 :queryRequest="(_)=>queryPayCondition({is_disabled: 0, ..._})"
                                 :findRequest="getPayCondition"
                                 clearable
                                 keyword-key="name"
                                 value-key="id"
                                 label-key="name"
                                 id-key="id">
                  </remote-select>
                  <div style="display:flex; flex-direction: row; margin-left: 4px">
                    <el-button v-if="index === 0"
                               size="mini"
                               @click="addConditions">添加
                    </el-button>
                    <el-button v-if="index > 0"
                               @click="deleteConditionAt(index)"
                               size="mini"
                               type="danger">删除
                    </el-button>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     :disabled="fileUploading"
                     native-type="submit">保存
          </el-button>
          <el-button v-if="id > 0" @click="$router.back()">返回</el-button>
          <el-button v-else @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
import { formRules } from '../customer-receipt.rules.js'

export default {
  components: {},
  data () {
    return {
      id: 0,
      fileUploading: false,
      formRules,
      form: {
        company_name: '',
        bank_info: '',
        address_phone: '',
        tax_number: '',
        attached_file: [],
        customer_ids: [{id: ''}],
        pay_condition_ids: [{id: ''}],
      },
      fileList: [],
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...request.map(['queryPayCondition', 'getPayCondition']),
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getCustomerReceiptDetail', {id}).then(({data}) => {
        data.customer_ids = data.customer_ids.map(id => ({ id: `${id}` }))
        if (data.pay_condition_ids.length > 0) {
          data.pay_condition_ids = data.pay_condition_ids.map(id => ({id}))
        } else {
          data.pay_condition_ids = [{id: ''}]
        }
        filter.setLoop(this.form, data)
      })
    },
    getForm () {
      const form = filter.copyJson(this.form)
      form.customer_ids = form.customer_ids.map(item => item.id).filter(Boolean)
      form.pay_condition_ids = form.pay_condition_ids.map(item => item.id).filter(Boolean)
      return form
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        const params = this.getForm()
        console.log(params)
        if (params.customer_ids.length < 1) {
          this.$message.error('使用客户不得为空！')
          return false
        }
        if (params.pay_condition_ids.length < 1) {
          this.$message.error('账期不得为空！')
          return false
        }
        if (valid) {
          this.id ? this.update(this.id, params) : this.submit(params)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create (params) {
      request.common('createCustomerReceiptData', params).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
          this.$refs.upload.clearFiles()
          this.form.customer_ids = [{id: ''}]
        }, () => {
          this.$router.push({path: '/customer-receipt/table/'})
        })
      })
    },
    submit (params) {
      request.common('getCustomerReceiptTable', {tax_number: this.form.tax_number}).then(({data}) => {
        if (data.total) {
          this.$confirm('该税号已存在，请确认是否添加？', '提示', {type: 'warning'}).then(() => {
            this.create(params)
          })
        } else {
          this.create(params)
        }
      })
    },
    update (id, params) {
      request.common('updateReceiptInfoData', {id, ...params}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/customer-receipt/table/'})
        })
      })
    },
    addCustomer () {
      this.form.customer_ids.push({
        id: ''
      })
    },
    deleteItemAt (index) {
      this.form.customer_ids.splice(index, 1)
    },
    addConditions () {
      this.form.pay_condition_ids.push({
        id: ''
      })
    },
    deleteConditionAt (index) {
      this.form.pay_condition_ids.splice(index, 1)
    },

    customerRemoteMethod (query) {
      return request.common('getCustomerTableForSearch', {keyword: query.keyword, type: 'all'})
    },
    getCustomerInfoRemote (id) {
      return request.common('getCustomerDetail', id)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    onChangeFile (file, fileList, index) {
      let isLt2M = file.raw.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.onUploadFile(file.raw, fileList, index)
    },
    onUploadFile (file, fileList) {
      this.fileUploading = true
      let formData = new FormData()
      formData.append('file', file)
      return request.alert('uploadCustomerReceiptAttachedFile', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)

        let type
        if ((file.name.substr(-5).toLowerCase() === '.jpeg') || (file.name.substr(-4).toLowerCase() === '.jpg') || (file.name.substr(-4).toLowerCase() === '.png')) {
          type = 'pic'
        } else if (file.name.substr(-4).toLowerCase() === '.pdf') {
          type = 'pdf'
        } else if (file.name.substr(-4).toLowerCase() === '.eml') {
          type = 'eml'
        }
        if (index > -1) {
          this.form.attached_file[index] = {name: file.name, url: data, type: type}
          this.fileList[index] = {name: file.name, url: data, type: type}
        }
        this.fileUploading = false
      }, () => {
        this.$refs.upload.uploadFiles.pop()
        this.fileUploading = false
      })
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    beforeRemove (file, fileList) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        this.form.attached_file.splice(index, 1)
      }
    },
    onGetPdfFile (item) {
      this.$confirm('确认下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': getToken()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '下载已取消',
        })
      })
    },
    onViewImage (event) {
      if (event.target.src) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>

.view-navbar {
  right: 0px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;
}
ul {
  transform: translateX(0px);
  transition: all 0.3s;
  box-sizing: content-box;
  overflow: hidden;
  padding: 1px 0;
}
li {
  float: left;
  list-style: none;
  width: 100px;
  height: 100px;
  margin-right: 5px;
  cursor: pointer;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
  transition: opacity 0.15s;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/customer-receipt/pages/CustomerReceiptForm.vue